module.exports = __webpack_public_path__ + "img/fb.548676c0.svg";